/**
 * Buyer vocabulary shared by the Buyer page and the Chrome extension's
 * research, so a theme the extension saves is one the page can show and edit.
 */
export const BUYER_THEMES = [
  "Founder/Owner Transitions",
  "Platform Add-ons / Bolt-ons",
  "Family-Owned Businesses",
  "Corporate Carve-outs",
  "Turnarounds / Special Situations",
  "Growth Equity",
  "Recapitalizations",
] as const;

/** acquisition_criteria.control_preference */
export const CONTROL_PREFERENCES = ["control", "minority", "both"] as const;
